import { Privacy } from '../components/privacy/types';
import { ActionData, Attachment } from '../lib/entities';
import { RichMediaState } from '../lib/state/rich-media-state';
import { calculateMeaningfulScore } from './calculate-meaningful-score';

export const actionData = ({
	attachment,
	calculateReceiversFn,
	calculateTotalFn,
	flashPointsBalance,
	hashtagMode,
	includeGiver,
	privacy,
	state,
	zeroPointBonuses,
}: {
	attachment: Attachment | null;
	calculateReceiversFn?: (includeGiver: boolean) => number;
	calculateTotalFn?: (data: RichMediaState, state: { includeGiver: boolean }) => number;
	flashPointsBalance: number;
	hashtagMode: string;
	includeGiver: boolean;
	privacy: Privacy;
	state: RichMediaState;
	zeroPointBonuses: boolean;
}) => {
	return new ActionData({
		attachment: attachment,
		amount: state.amount ?? null,
		flashPointsUsed: flashPointsBalance > 0 && state.totalAmount > 0,
		hashtags: state.hashtags,
		hasAmount: state.hasAmount,
		hasHashtag: state.hasHashtag,
		hasRecipient: state.hasRecipient,
		includeGiver: includeGiver,
		meaningfulScore: calculateMeaningfulScore({
			state,
			hashtagMode,
			zeroPointBonuses,
			attachment,
		}),
		mentions: state.mentions,
		recipients: state.recipients,
		privacy: privacy,
		text: state.text,
		totalAmount: calculateTotalFn?.(state, { includeGiver }) || state.totalAmount,
		recipientCount: calculateReceiversFn?.(includeGiver) || state.recipientCount,
	});
};
